export default __webpack_public_path__ + "bab504302f3f98517989816cddac39e4.png";